/**
 * Select Widget for RUL Forms
 */

import { Select } from 'antd';
import type { SelectWidget } from '@/api/types/rul.types';

interface SelectWidgetProps {
  widget: SelectWidget;
  onChange: (name: string, value: any) => void;
  error?: string;
}

export const SelectWidgetComponent: React.FC<SelectWidgetProps> = ({
  widget,
  onChange,
  error,
}) => {
  if (!widget.visible) return null;

  return (
    <div className="rul-field">
      {widget.label && (
        <label className="rul-field-label">
          {widget.label}
          {widget.required && <span className="rul-field-required">*</span>}
        </label>
      )}
      <Select
        value={widget.value || undefined}
        placeholder={widget.placeholder}
        disabled={!widget.enabled}
        status={error ? 'error' : undefined}
        style={{ width: '100%' }}
        mode={widget.multiple ? 'multiple' : undefined}
        onChange={(value) => onChange(widget.name, value)}
        options={widget.options}
      />
      {widget.help_text && !error && (
        <div className="rul-field-help">{widget.help_text}</div>
      )}
      {error && <div className="rul-field-error">{error}</div>}
    </div>
  );
};
